import UserSignatureModal from "components/settings/user/UserSignatureModal";
import { get } from "lodash";
import PropTypes from "prop-types"; 
import React from "react";
import { connect } from "react-redux";

function ProfileChangeSignature({ onClose, userId }) {
    return <UserSignatureModal userId={userId} onClose={onClose} />;
}

export default connect((state) => {
    return {
        userId: get(state.login.user, "id", null),
    };
})(ProfileChangeSignature);

ProfileChangeSignature.propTypes = {
    onClose: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
};
